import moment from 'moment';
import firebase from 'firebase/app';
import 'firebase/firestore';

export default class Logger {
    static findDiff(a, b, ignoredFields, fields){
        let Akeys = Object.keys(a).filter(key => !ignoredFields.includes(key) && fields.includes(key));
        // console.log("A")
        let Bkeys = Object.keys(b).filter(key => !ignoredFields.includes(key) && fields.includes(key));
        // console.log("B")
        let diff = [];
        // console.log("first loop")
        if(Akeys.length > 0){
            Akeys.forEach(key => {
                if(key === "mass"){
                    // console.log('object', a[key], typeof a[key], key);
                    let subAkeys = Object.keys({...a[key]});
                    subAkeys.forEach((subKey) => {
                        // console.log(subKey, a[key][subKey],b[key][subKey]);
                        // console.log(a[key][subKey] !== b[key][subKey]);
                        if((b[key] && a[key]) && a[key][subKey] !== b[key][subKey]){
                            diff.push(key +"_"+subKey +": "+ a[key][subKey] +" => "+ b[key][subKey]);
                        }
                    });
                }else if(!key.includes("$") && a[key]!== undefined && b[key] !== undefined && b[key] !== a[key] && (typeof a[key] !== 'object' && typeof b[key] !== 'object')){
                    if(isNaN(a[key]) && isNaN(b[key])){
                        diff.push(key+": "+a[key] + " => " + b[key]);
                    }else if(parseFloat(a[key]) !== parseFloat(b[key])){
                        diff.push(key+": "+a[key] + " => " + b[key]);
                    }
                }
            });
        }
        // // console.log('second loop');
        Bkeys.forEach(key => {
            if(a[key] === undefined && typeof b[key] !== "object" && b[key] !== undefined){
                diff.push(key+": +"+b[key])
            }
        });
        return diff;
    }
    
    static save(payload){
        // console.log(payload, 'logging');
        // console.log(payload, 'diff');
        let extraKeys = Object.keys(payload.newVal);
        let uuids = {};
        extraKeys.forEach(key => {
            if(key.includes('uuid') && !key.includes("unit_uuid") && key !== "uuid"){
                uuids[key] = payload.newVal[key]
            }
        });
        let logObject = {
            class: payload.class,
            uuid: payload.uuid,
            type: payload.type,
            ...uuids,
            diff: this.findDiff(payload.oldVal, payload.newVal, payload.ignoredFields, Object.keys(payload.fields)),
            timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            user_id: payload.user_id,
            user_name: payload.user_name,
        };
        // console.log(logObject);
        if(logObject.diff.length < 1)return;
        // console.log(logObject, "log");
        console.log(logObject);
        firebase.firestore().collection("belit_logs").add(logObject).catch(err => console.log(err));
    }
    
    static logDelete(payload){
        let logObject = {
            class: payload.class,
            uuid: payload.uuid,
            type: "DELETE",
            diff: [payload.deleted + " => " + "DELETED"],
            timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            user_id: payload.user_id,
            user_name: payload.user_name,
        };
        firebase.firestore().collection("belit_logs").add(logObject).catch(err => console.log(err));
    }
    
    static logRestore(payload){
        let logObject = {
            class: payload.class,
            uuid: payload.uuid,
            type: payload.type ? payload.type : "CUSTOM",
            diff: [payload.diff],
            timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            user_id: payload.user_id,
            user_name: payload.user_name,
        };
        firebase.firestore().collection("belit_logs").add(logObject).catch(err => console.log(err));
    }
    static logCustom(payload){
        let logObject = {
            class: payload.class,
            uuid: payload.uuid,
            type: "RESTORE",
            diff: [payload.deleted + " => " + "RESTORED"],
            timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            user_id: payload.user_id,
            user_name: payload.user_name,
        };
        firebase.firestore().collection("belit_logs").add(logObject).catch(err => console.log(err));
    }
    static devLog(payload){
        firebase.firestore().collection('api_error_logs').add({
            ...payload,
            timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        }).catch(err => console.log(err))
    }
}
